import React, { FC, useCallback, useState } from 'react'
import { isNaN } from 'lodash'
import { Flex } from '@chakra-ui/layout'

import { money } from '@gaia-family/lib'

import { Input, InputProps } from '../Input'

export type CurrencyProps = Omit<InputProps, 'value' | 'onChange'> & {
  value?: money.Money<number>
  dataCy?: string
  locale?: 'en-US' | 'en-GB'
  onChange: (v: money.Money<number>) => void
}

export const CurrencyInput: FC<CurrencyProps> = ({
  value = money.create({ amount: 0, currency: money.GBP }),
  dataCy,
  locale = 'en-GB',
  onChange,
  ...props
}) => {
  const [input, setInput] = useState(value)
  const currency = value.toJSON().currency

  const transformer = useCallback(
    ({
      amount,
      currency,
    }: {
      amount: number
      currency: money.Currency<number>
    }) =>
      amount.toLocaleString(locale, {
        style: 'currency',
        currency: currency.code,
      }),
    [locale]
  )

  return (
    <Flex data-cy={dataCy} width="100%">
      <Input
        inputMode="decimal"
        {...props}
        onChange={(e) => {
          const parsedValue =
            parseFloat(e.target.value.replace(/[^0-9\.-]+/g, '')) * 100

          const nextInput = money.create({
            amount: isNaN(parsedValue) ? 0 : parsedValue,
            currency: currency,
          })

          if (!money.equal(input, nextInput)) {
            onChange(nextInput)
          }
          setInput(nextInput)
        }}
        value={money.toFormat(input, transformer).replace(/\.\d+/, '')}
      />
    </Flex>
  )
}
